module.exports = __webpack_public_path__ + "img/Slide10.becf7ab8.png";